import { type ReactNode } from "react";
import classNames from "classnames";

interface Props<T extends {}> {
  className?: string;
  data: T[];
  render: (item: T) => ReactNode;
  getKey: (item: T) => string;
}

export const MobileScrollableTileContainer = <T extends {}>({ className, render, data, getKey }: Props<T>) => {
  return (
    <ul className={classNames("scha__mobile__scrollable-tile-container", className)}>
      {data.map((item) => (
        <li className={"scha__mobile__scrollable-tile-container__item"} key={getKey(item)}>
          {render(item)}
        </li>
      ))}
    </ul>
  );
};
